import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import hero2Styles from './Hero2Styles';
// import Button from "../Button/Button";
import EndIconButton from "../EndIconButton/EndIconButton";
import { ReactComponent as Hero2SVG } from '../../icons/svgHgo.svg';
import ReactWhatsapp from "react-whatsapp";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

type ContentProps = {

};

const StyledHero2 = styled('section')(({ theme }) => hero2Styles(theme));

const oakHeroClassNames = {
  heroContainer: "grid max-w-screen-xl px-8 sm:px-16 pb-20 pt-32 mx-auto lg:gap-8 xl:gap-0 sm:pb-24 lg:pb-32 lg:pt-48 lg:grid-cols-12 relative !z-[2]",
  heroInnerContainer: "mr-auto place-self-center lg:col-span-7",
  heroTitle: "max-w-2xl mb-8 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-8xl",
  heroSubtitle: "max-w-2xl mb-6 font-light lg:mb-12 md:text-lg lg:text-xl",
  heroButtonContainer: "flex flex-col sm:flex-row",
  heroButton: "mr-4 mb-4 sm:mb-0 hover:bg-green-700 bg-green-500",
  heroImgContainer: "hidden lg:mt-0 lg:col-span-5 lg:flex h-full relative"
}

const Hero2: React.FC<ContentProps> = () => (
  <Fragment>
      <StyledHero2 className="relative">
        <div className={oakHeroClassNames.heroContainer}>
            <div className={oakHeroClassNames.heroInnerContainer}>
              <h1 id="hero-title" className={oakHeroClassNames.heroTitle}>Renta de cajas secas en Hidalgo con disponibilidad inmediata</h1>
              <p id="hero-subtitle" className={oakHeroClassNames.heroSubtitle}>En Grupo GM contamos con más de 50 cajas secas listas para renta en todo el estado de Hidalgo y zona centro del país.</p>
              <div className={oakHeroClassNames.heroButtonContainer}>
                <ReactWhatsapp className="border-none mr-4 mb-4 sm:mb-0 px-4 transition-colors duration-100 hover:bg-green-600 h-[3rem] flex items-center w-fit bg-green-500 text-white rounded-[10px] shadow-sm text-[1rem]" element="button" number="+52 7711580540" message="Hola, me gustaría conocer más sobre ustedes."><WhatsAppIcon fontSize='medium' className="pr-2"/> Cotizar por WhatsApp</ReactWhatsapp>
                <EndIconButton phoneNumber="7711580540" >Llamar ahora</EndIconButton>
              </div>
            </div>
            <div className={oakHeroClassNames.heroImgContainer} title="Renta de cajas secas en Hidalgo">
              <div className="absolute bottom-0 right-0 top-0 left-0 flex items-center justify-center"><div id="hero-map-circle" className="h-48 w-48 rounded-full mr-10"></div></div>
              <Hero2SVG className='h-full hidden lg:flex mr-12 z-10' href=""/>
            </div>                
        </div>
        <div className="absolute z-[1] top-0 left-0 bottom-0 right-0 font-black text-9xl mt-20 sm:text-[12rem] md:text-[12rem] lg:mt-[-8rem] lg:text-[17rem] justify-start lg:justify-center xl:text-[20rem] 2xl:text-[25rem] font-[IndustryTest] text-zinc-800 flex flex-col items-center overflow-hidden">
          <div className="container font-[IndustryTest] text-nowrap opacity-50">Grupo GM</div>
        </div>
      </StyledHero2>
    </Fragment>
);

export default Hero2;